var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "guardrail-details" },
    [
      _c("h5", [_vm._v("Preprocessing Guardrails")]),
      _vm._v(" "),
      _vm._l(_vm.guardrails, function(guardrail, index) {
        return _c(
          "div",
          { key: `${index}_${guardrail.op}`, staticClass: "guardrail-content" },
          [
            _c("span", { staticClass: "guardrail-type" }, [
              _vm._v(_vm._s(_vm.formatGuardrailType(guardrail.op)))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "guardrail-message" }, [
              _vm._v(_vm._s(guardrail.message))
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }